import { useState } from "react";
import CustomOptionBox from "./CustomOptionBox";
import CustomOptionSingleSelect from "./CustomOptionSingleSelect";
import Option from "./Option";

export default function EnhanceSelectBox({ state, setState, label, additionalAction }) {
    const [isActive, setIsActive] = useState(false);
    const handleRade = (field) => {
        Object.keys(state).forEach(key => {
            if (state[key]) {
                state[key] = false;
            }
        });
        setState({
            ...state,
            [field]: true,
        })
        setIsActive(!isActive);
        additionalAction({
            ...state,
            [field]: true,
        })
    }
    const radeCheckLists = Object.keys(state).map((key, index) => (<Option label={key} key={index} data={state} handleCheck={() => handleRade(key)} />));

    const handleRadeBox = () => {
        setIsActive(!isActive);
    }

    let stateList = "";
    Object.keys(state).forEach(key => {
        if (state[key]) {
            stateList = stateList + key
        }
    });

    return (
        <>
            <CustomOptionSingleSelect value={stateList} label={label} handleClick={(e) => { handleRadeBox(); e.stopPropagation() }} />
            <CustomOptionBox isActive={isActive} isSingleSelect={true} clickHandle={handleRadeBox}>
                <div className="flex flex-row justify-between w-full">
                    <div className="w-full">
                        {radeCheckLists}
                    </div>
                </div>
            </CustomOptionBox>
        </>
    )
}